@import './../scss/pk-toast.variables';

:host {
  @apply bottom-0 mb-[--toast--spacing] flex justify-between rounded-r-s bg-[color:--toast--bg-color] p-m shadow-02;
  @apply border-b-0 border-l-4 border-r-0 border-t-0 border-solid border-transparent;
  @apply transition-transform delay-[60ms] ease-in-out;

  animation: toast-out-bottom 0.7s;
}

:host(.place-bottom) {
  animation: toast-in-bottom 0.7s;
}

:host(.success) {
  @apply border-l-[color:--toast--border-color-success];

  .pk-toast-item__base--icon {
    @apply [--pk-icon--color:--toast--icon-color-success];
  }
}

:host(.error) {
  @apply border-l-[color:--toast--border-color-error];

  .pk-toast-item__base--icon {
    @apply [--pk-icon--color:--toast--icon-color-error];
  }
}

:host(.warning) {
  @apply border-l-[color:--toast--border-color-warning];

  .pk-toast-item__base--icon {
    @apply [--pk-icon--color:--toast--icon-color-warning];
  }
}

:host(.custom) {
  @apply border-l-[color:--toast--border-color];

  .pk-toast-item__base--icon {
    @apply [--pk-icon--color:--toast--border-color];
  }
}

%content-common {
  ::slotted(*) {
    @apply font-bold text-s leading-m text-text-01;
  }
}

.pk-toast-item__content--title {
  @extend %content-common;
}

.pk-toast-item__content--body {
  @extend %content-common;

  ::slotted(*) {
    @apply font-regular leading-l;
  }
}

.pk-toast-item__close--btn {
  &::part(button) {
    @apply border-none bg-transparent p-0 [--button--color:--pk-ui-04];
    @apply hover:[--button--color:--pk-ui-02] active:[--button--color:--pk-ui-05];
  }
}

@keyframes toast-in-bottom {
  from {
    transform: translateY(calc(100% + var(--toast--spacing)));
  }

  to {
    transform: translateY(0);
  }
}

@keyframes toast-out-bottom {
  from {
    transform: translateY(0);
  }

  to {
    transform: translateY(calc(100% + var(--toast--spacing)));
  }
}
